import { render, staticRenderFns } from "./ModalPieStudentSecondSpecialTable.vue?vue&type=template&id=c468dcc4"
import script from "./ModalPieStudentSecondSpecialTable.vue?vue&type=script&lang=js"
export * from "./ModalPieStudentSecondSpecialTable.vue?vue&type=script&lang=js"
import style0 from "./ModalPieStudentSecondSpecialTable.vue?vue&type=style&index=0&id=c468dcc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports